import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';
import { COOKIESTXT } from './cookies-data';

@Component({
  selector: 'neo-pagina-cookies',
  templateUrl: './pagina-cookies.component.html',
  styleUrls: ['./pagina-cookies.component.scss', '../../components/contentBlocks/contentStyledText/contentStyledText.component.scss']
})
export class PaginaCookiesComponent implements OnInit {

  cookiebotId = this.preferenciasService.get('matrix_cookiebot');
  @ViewChild('test') test: TemplateRef<any>;
  @ViewChild('ngxCookiebot', { static: true }) ngxCookiebotElement: ElementRef;
  constructor(
    private _ngxCookiebotConfig: NgxCookiebotConfig,
    @Inject(COOKIESTXT) public cookiesTxt,
    private configTitulo: ConfigTituloPaginasService,
    public preferenciasService: PreferenciasService
  ) { }

  ngOnInit(): void {
    this.configTitulo.establecerTitulo('Política de Cookies');
    // Debido a el no funcionamiento del compoenente de la libreria ngx-cookiebot-declaration, replicamos su funcionalidad directamente
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'CookieDeclaration';
    script.src = 'https://consent.cookiebot.com/' + this._ngxCookiebotConfig.cbId + '/cd.js';
    script.async = true;
    this.ngxCookiebotElement.nativeElement.append(script);
  }

}
